import { wsClient, WsRecvType, IWsHandler } from '../client'

export interface IChannelCalibrationStatus {
    clientId: string
    channelNum: number
    isCalibrating: number // 1 = in progress, 0 = completed
    elapsedMs: number
    finalDurationMs: number
}

type IChannelCalibrationStatusHandler = IWsHandler<IChannelCalibrationStatus>

const listeners: Array<(data: IChannelCalibrationStatus) => void> = []

export function onChannelCalibrationStatus(callback: (data: IChannelCalibrationStatus) => void) {
    listeners.push(callback)
    return () => {
        const index = listeners.indexOf(callback)
        if (index > -1) {
            listeners.splice(index, 1)
        }
    }
}

export default function () {
    wsClient.submitHandler(WsRecvType.ChannelCalibrationStatus, ((packet) => {
        console.log('[WsClient] ChannelCalibrationStatus', packet.data)
        if (packet.data) {
            const data = packet.data
            listeners.forEach(listener => listener(data))
        }
    }) as IChannelCalibrationStatusHandler)
}
